import React from 'react';

import { LETTERS, NUMBERS, SIGNS } from '../../symbols/keys';
import { ReferenceSection } from './components';

const sections: { symbols: string[]; heading: string }[] = [
  {
    symbols: LETTERS,
    heading: 'Letters',
  },
  {
    symbols: NUMBERS,
    heading: 'Numbers',
  },
  {
    symbols: SIGNS,
    heading: 'Signs',
  },
];

export const Reference = () => {
  return (
    <div className="flex justify-center flex-col w-full max-w-xl">
      <div className="prose">
        <h2>Braille Reference</h2>
      </div>
      {sections.map(({ symbols, heading }) => (
        <ReferenceSection key={heading} symbols={symbols} heading={heading} />
      ))}
    </div>
  );
};
